export default __webpack_public_path__ + "static/media/search.58256e1f.svg";